const DEFAULT_STOP_TIMEOUT_MS = 5_000;

/**
 * Stop a MediaRecorder and wait until the browser has emitted its final
 * dataavailable event. Reading chunks immediately after stop() can otherwise
 * produce an empty or truncated recording.
 */
export function stopMediaRecorder(
  recorder: MediaRecorder | null,
  timeoutMs = DEFAULT_STOP_TIMEOUT_MS,
): Promise<void> {
  if (!recorder || recorder.state === 'inactive') {
    return Promise.resolve();
  }

  return new Promise((resolve) => {
    let settled = false;
    let timeoutId: ReturnType<typeof setTimeout> | null = null;

    const finish = () => {
      if (settled) return;
      settled = true;
      if (timeoutId) clearTimeout(timeoutId);
      recorder.removeEventListener('stop', finish);
      resolve();
    };

    recorder.addEventListener('stop', finish, { once: true });
    timeoutId = setTimeout(finish, timeoutMs);

    try {
      recorder.stop();
    } catch {
      finish();
    }
  });
}
